<div class="component-main">
    <div class="content-space-between">
        <h1>{{ 'billing' | myLbTranslate }}</h1>
        <button class="primary" (click)="contactSales('I needed help with billing')">
            {{ 'billing_contact' |myLbTranslate }}
        </button>
    </div>
    <app-tab-container>
        <app-tab id="items" tabTitle="billing_items">
            <app-table id="billing-items" [data]="billingRows">
                <app-column [flexGrow]="0.3" prop="item" label="billing_item"></app-column>
                <app-column [flexGrow]="0.5" prop="description" label="description"></app-column>
                <app-column [flexGrow]="0.5" prop="status" label="status"></app-column>
                <app-column [flexGrow]="0.5" prop="cost" label="billing_monthly_cost"></app-column>
                <app-column
                    [flexGrow]="1"
                    prop="actions"
                    label=""
                    cellAlignment="right"
                    [cellTemplate]="billingActions">
                    <ng-template let-row #billingActions>
                        <app-action-dots>
                            <button
                                appHint
                                id="billing-cancel-subscription"
                                name="cancel subscription"
                                [hintText]="row.status === 'Canceled' ? ('billing_remove_subscription_hint' | myLbTranslate) : ''"
                                hintPosition="left"
                                [disabled]="!permissionsLookup['billing-cancel-subscription'] || row.status === 'Canceled'"
                                (click)="confirmCancelSubscription(row)">
                                {{ 'billing_cancel_plan' | myLbTranslate }}
                            </button>
                        </app-action-dots>
                    </ng-template>
                </app-column>
            </app-table>
        </app-tab>

        <!--  Payment Methods  -->

        <app-tab id="methods" tabTitle="billing_payment_methods" [disabled]="stripeDisabled">
            <app-table id="billing-payment-methods" [data]="methodRows">
                <app-column [flexGrow]="1" prop="brand" label="billing_payment_method" [cellTemplate]="paymentMethod">
                    <ng-template let-row #paymentMethod>
                        <img
                            ngSrc="{{row.brandLogoPath}}"
                            [class.expired]="row.expired"
                            class="card-icon"
                            width="32"
                            height="32"
                            alt="payment card icon for {{row.brand}}">
                        <strong [class.expired]="row.expired">{{ row.brand | titlecase }}</strong>
                        <span [class.expired]="row.expired" class="card-ending">
                            {{ 'billing_card_ending' | myLbTranslate }} {{ row.last4 }}
                        </span>
                    </ng-template>
                </app-column>
                <app-column [flexGrow]="1" prop="expiry" label="billing_expiry" [cellTemplate]="expiry">
                    <ng-template let-row #expiry>
                        <span [class.expired]="row.expired" class="card-ending">{{ row.expiry }}</span>
                    </ng-template>
                </app-column>
                <!-- TODO can't do atm -->
                <!--                <app-column [flexGrow]="1" prop="default" label="default" [cellTemplate]="default">-->
                <!--                    <ng-template let-row #default>-->
                <!--                        <img-->
                <!--                            *ngIf="row.default"-->
                <!--                            ngSrc="assets/shared/icons/bullet-tick.svg"-->
                <!--                            alt="tick"-->
                <!--                            height="9"-->
                <!--                            width="13"/>-->
                <!--                    </ng-template>-->
                <!--                </app-column>-->
                <app-column
                    [flexGrow]="1"
                    prop="actions"
                    label=""
                    cellAlignment="right"
                    [cellTemplate]="methodActions">
                    <ng-template let-row #methodActions>
                        <app-action-dots>
                            <!-- TODO can't do atm -->
                            <!--                            <button-->
                            <!--                            id="billing-make_default_method"-->
                            <!--                                name="make-default"-->
                            <!--                                [disabled]="row.default || true"-->
                            <!--                                (click)="makeCardDefault(row)">-->
                            <!--                                {{ 'billing_make_default' | myLbTranslate }}-->
                            <!--                            </button>-->
                            <button
                                id="billing-edit-payment_method"
                                name="edit-payment"
                                [disabled]="!permissionsLookup['billing-edit-payment_method']"
                                [routerLink]="'/cm/organisation/billing/edit-card/' + row.id">
                                {{ 'billing_edit_payment_method' | myLbTranslate }}
                            </button>
                            <button
                                id="billing-delete-payment_method"
                                name="remove-payment-method"
                                [disabled]="!permissionsLookup['billing-delete-payment_method']"
                                (click)="confirmRemovePaymentMethod(row)">
                                {{ 'billing_remove_payment' | myLbTranslate }}
                            </button>
                        </app-action-dots>
                    </ng-template>
                </app-column>
            </app-table>
            <button
                id="billing-add-payment_method"
                class="button-as-link"
                [disabled]="!permissionsLookup['billing-add-payment_method']"
                [routerLink]="'/cm/organisation/billing/payment-method'">
                {{ 'billing_add_payment_method' | myLbTranslate }}
            </button>
        </app-tab>
        <app-tab id="history" tabTitle="billing_invoice_history" [disabled]="stripeDisabled">
            <app-table id="invoice-history" [data]="historyRows">
                <app-column [flexGrow]="0.3" prop="invoice" label="billing_invoice"></app-column>
                <app-column [flexGrow]="0.5" prop="date" label="billing_date"></app-column>
                <app-column [flexGrow]="0.5" prop="amount" label="billing_amount"></app-column>
                <app-column [flexGrow]="0.5" prop="status" label="status" [cellTemplate]="invoiceStatus">
                    <ng-template let-row #invoiceStatus>
                        {{ row.status | myLbTranslate }}
                    </ng-template>
                </app-column>
                <app-column [flexGrow]="0.5" prop="download" label="download" [cellTemplate]="downloadIcon">
                    <ng-template let-row #downloadIcon>
                        <ng-container *ngIf="row.download">
                            <a [href]="row.download" class="no-underline" rel="noreferrer" target="_self">
                                <img
                                    ngSrc="assets/centralisedManagement/icons/download.svg"
                                    alt="download icon"
                                    class="download-icon"
                                    height="21"
                                    width="21"/>
                            </a>
                        </ng-container>
                    </ng-template>
                </app-column>
                <app-column
                    [flexGrow]="1"
                    prop="actions"
                    label=""
                    cellAlignment="right"
                    [cellTemplate]="invoiceActions">
                    <ng-template let-row #invoiceActions>
                        <app-action-dots>
                            <button
                                id="billing_download-invoice"
                                name="download"
                                [disabled]="false"
                                (click)="downloadInvoice(row)">
                                {{ 'download' | myLbTranslate }}
                            </button>
                        </app-action-dots>
                    </ng-template>
                </app-column>
            </app-table>
        </app-tab>
    </app-tab-container>
</div>

<app-modal-wrapper
    [isOverlayBlurred]="false"
    [isOverlayClickable]="true"
    modalId="cancelSubscription"
    modalTitle="billing_edit_subscription"
    modalWidth="400"
    footerButtonAlignment="content-center"
    [showCloseButton]="true">
    <app-modal-body>
        Select the subscription you wish to cancel or edit
    </app-modal-body>
    <app-modal-footer>
        <button class="primary" (click)="modalService.close('cancelSubscription')">{{ 'ok' | myLbTranslate }}</button>
    </app-modal-footer>
</app-modal-wrapper>
